// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const SET_THEME_MODE = '@customization/SET_THEME_MODE';
export const SET_SIDEBAR_WIDTH = '@customization/SET_SIDEBAR_WIDTH';
export const SET_PALETTE = '@customization/SET_PALETTE';

export const SET_AUTHENTICATED = '@user/SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = '@user/SET_UNAUTHENTICATED';
export const SET_USER = '@user/SET_USER';
export const LOADING_USER = '@user/LOADING_USER';
export const STOP_LOADING_USER = '@user/STOP_LOADING_USER';
export const SET_USER_ERROR = '@user/SET_USER_ERROR';
export const SET_AUTHENTICATION_METHOD_SSO = '@user/SET_AUTHENTICATION_METHOD_SSO';
export const SET_AUTHENTICATION_METHOD_IDM = '@user/SET_AUTHENTICATION_METHOD_IDM';
export const SET_AUTHENTICATION_METHOD_LOCAL = '@user/SET_AUTHENTICATION_METHOD_LOCAL';
export const SET_AUTHENTICATION_METHOD_VIISP = '@user/SET_AUTHENTICATION_METHOD_VIISP';
